<div class="content">
    
    <app-section [seccionInput]="seccion"></app-section>
    <app-tarjetas-items [tarjetas]="listaTarjetas" (categoriaElegidaEmit)="getVideos($event)"></app-tarjetas-items>
    <a name="videosRec"></a>
    <br>
    <br>
    <app-tarjetas-videos *ngIf="listaVideos.length>0" [lista]="listaVideos" [categoria]="categoriaElegida"
        [videoElegido]="videoSeleccionado"></app-tarjetas-videos>
</div>